<template>
  <div class="errors" v-if="errors.length">
    <b-alert
        show="10"
        variant="danger"
        fade
        v-for="(error, i) in errors"
        v-bind:key=i
    >
      {{ $t(error) }}
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'Error',
  props: ['errors']
}
</script>

<style scoped lang="scss">
</style>
